import { memo } from "react";
import FileUploadList from "ui/components/FileUpload/FileUploadList/FileUploadList";
import { InvoiceIncomingDocumentsProps } from "./types";

const InvoiceIncomingDocuments: React.FC<InvoiceIncomingDocumentsProps> = ({ documents, activeDocId, onDocumentClick }) => {
  if (!documents || documents.length === 0) {
    return <div className="text-sm text-slate-400 text-center py-8">Nema dokumenata</div>;
  }

  return (
    <FileUploadList
      files={documents}
      activeId={activeDocId}
      onItemClick={onDocumentClick}
    />
  );
};

export default memo(InvoiceIncomingDocuments);
